// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --accentColor: #008ef4;
  --accentLightColor: rgba(0, 142, 244, 0.1);
  --textOnAcccentColor: white;
  --backgroundColor: #f5f5f5;
  --backgroudSecondaryColor: white;
  --textColor: black;
  --textSecondaryColor: gray;
  --errorColor: red;
  --grayColor: #0000007a;
  --grayLightColor: #0000002b;
  --grayOnAccentColor: #ffffffdb;
  --grayLightOnAccentColor: #ffffff3a;
}

.textController_inputGroup__LIoxC {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.textController_inputContainer__mZS7c {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.textController_inputContainer__mZS7c .textController_label__8JgTt {
  font-size: 15px;
}
.textController_inputContainer__mZS7c .textController_input__0hMD8 {
  all: unset;
  box-sizing: border-box;
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--textSecondaryColor);
  background-color: var(--backgroundColor);
  padding: 15px;
  font-weight: 600;
}
.textController_inputContainer__mZS7c .textController_input__0hMD8:focus {
  outline: none;
  border: 1px solid var(--accentColor);
}
.textController_inputContainer__mZS7c .textController_input__0hMD8:disabled {
  cursor: not-allowed;
}
.textController_inputContainer__mZS7c .textController_error__5lpur {
  border: 1px solid var(--errorColor);
}
.textController_inputContainer__mZS7c .textController_error__5lpur:focus {
  outline: none;
  border: 1px solid var(--errorColor);
}
.textController_inputContainer__mZS7c .textController_errorText__HSZaw p {
  color: var(--errorColor);
}
.textController_inputContainer__mZS7c .textController_requiredIndicator__DxRgR {
  color: var(--errorColor);
}`, "",{"version":3,"sources":["webpack://./src/styles/vars.scss","webpack://./src/components/textController/textController.module.scss"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,0CAAA;EACA,2BAAA;EACA,0BAAA;EACA,gCAAA;EACA,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,sBAAA;EACA,2BAAA;EACA,8BAAA;EACA,mCAAA;ACDF;;AAXA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAcF;;AAVA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAaF;AAXE;EACE,eAAA;AAaJ;AAVE;EACE,UAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,2CAAA;EACA,wCAAA;EACA,aAAA;EACA,gBAAA;AAYJ;AAVI;EACE,aAAA;EACA,oCAAA;AAYN;AATI;EACE,mBAAA;AAWN;AAPE;EACE,mCAAA;AASJ;AAPI;EACE,aAAA;EACA,mCAAA;AASN;AAJI;EACE,wBAAA;AAMN;AAFE;EACE,wBAAA;AAIJ","sourcesContent":["$mobileBP: 900px;\n\n:root {\n  --accentColor: #008ef4;\n  --accentLightColor: rgba(0, 142, 244, 0.1);\n  --textOnAcccentColor: white;\n  --backgroundColor: #f5f5f5;\n  --backgroudSecondaryColor: white;\n  --textColor: black;\n  --textSecondaryColor: gray;\n  --errorColor: red;\n  --grayColor: #0000007a;\n  --grayLightColor: #0000002b;\n  --grayOnAccentColor: #ffffffdb;\n  --grayLightOnAccentColor: #ffffff3a;\n}\n","@import \"../../styles/vars.scss\";\n\n.inputGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n\n}\n\n.inputContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n\n  .label {\n    font-size: 15px;\n  }\n\n  .input {\n    all: unset;\n    box-sizing: border-box;\n    width: 100%;\n    border-radius: 10px;\n    border: 1px solid var(--textSecondaryColor);\n    background-color: var(--backgroundColor);\n    padding: 15px;\n    font-weight: 600;\n\n    &:focus {\n      outline: none;\n      border: 1px solid var(--accentColor);\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n    }\n  }\n\n  .error {\n    border: 1px solid var(--errorColor);\n\n    &:focus {\n      outline: none;\n      border: 1px solid var(--errorColor);\n    }\n  }\n\n  .errorText {\n    p {\n      color: var(--errorColor);\n    }\n  }\n\n  .requiredIndicator {\n    color: var(--errorColor);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputGroup": `textController_inputGroup__LIoxC`,
	"inputContainer": `textController_inputContainer__mZS7c`,
	"label": `textController_label__8JgTt`,
	"input": `textController_input__0hMD8`,
	"error": `textController_error__5lpur`,
	"errorText": `textController_errorText__HSZaw`,
	"requiredIndicator": `textController_requiredIndicator__DxRgR`
};
export default ___CSS_LOADER_EXPORT___;
